import { STUDY_DEMO_LEARNER } from './exampleData';
/** Fictional persona and fixed local IDs; never credentials or a real student record. */
export const SAMPLE_PROFILE = {
  name: STUDY_DEMO_LEARNER.name,
  nickname: 'Alex',
  age: STUDY_DEMO_LEARNER.age,
  year: STUDY_DEMO_LEARNER.year,
  school: STUDY_DEMO_LEARNER.school,
  location: 'Brisbane, Queensland',
  term: 'Term 4',
  background:
    'A Year 10 learner revisiting fractions and earlier science foundations alongside the mathematics workbook. Prepared source-linked notes, explanations and practice show what to keep, try and revisit.',
};
export const SAMPLE_IDS = {
  document: 'example-material-fractions',
  analysis: 'example-analysis-fractions',
  note: 'example-material-notes',
  set: 'example-practice-fractions',
  working: 'ee1a1111-1111-4111-8111-111111111111',
  explanation: 'example-session-fractions-explanation',
};
export const SAMPLE_WORKSPACE_PATH = '/try/study/student#/learn/study';
export const sampleExitPath = '/try/study';
export const sampleAnalysisPath = `/learn/study/materials/${SAMPLE_IDS.document}/analysis?analysis=${SAMPLE_IDS.analysis}`;
export const sampleExplanationPath = `/learn/study/sessions/${SAMPLE_IDS.explanation}?analysis=${SAMPLE_IDS.analysis}&question=example-pizza-source&message=example-explanation-reply`;
